import { MENU_ITEMS_SERVICE } from "@/services/menuItems.service.js";

const state = { listOutput: null};

const actions = {
    getList({ dispatch, commit }) {
        dispatch('alert/clear', null, { root: true });
        commit('listRequest');

        MENU_ITEMS_SERVICE.list()
            .then(
                output => {
                    commit('listSuccess', output);
                },
                error => {
                    commit('listFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
};

const mutations = {
    /* List */
    listRequest(state) {
        state.listOutput = null;
    },
    listSuccess(state, output) {
        state.listOutput = output;
    },
    listFailure(state) {
        state.listOutput = false;
    },
};

export const menuItems = {
    namespaced: true,
    state,
    actions,
    mutations
};
